module.exports = __webpack_public_path__ + "img/widget-center.bf5e2ccb.svg";